import { BasiliskJobMetadata } from 'modules/basilisk/basilisk.model';
import { MOCK_FILE_TYPE_IDS } from '../context/context.const';

/**
 * Tipos e helpers dos perfis de job (documentos, tempos, falha e resultado), usados
 * pelos perfis escritos à mão (jobs.const) e pelos gerados (jobs-generated.const).
 */

/** Instante de referência: as datas relativas (`createdDaysAgo`) ficam estáveis durante a sessão */
export const MOCK_EPOCH_MS = Date.now();

export const SECOND_MS = 1_000;
export const MINUTE_MS = 60 * SECOND_MS;
export const HOUR_MS = 60 * MINUTE_MS;
export const DAY_MS = 24 * HOUR_MS;

export interface MockJobDocumentSeed {
	filename: string;
	fileTypeId: string;
	pageCount: number;
	sizeBytes: number;
	/** Nome exibido do tipo (sobrepõe o do catálogo de tipos de arquivo) */
	fileTypeName?: string;
}

export interface MockJobProfile {
	/** Minutos antes de "agora" (somados aos `createdDaysAgo` do roster) */
	minutesAgo: number;
	queueMs: number;
	processingMs: number;
	/** Contestação/Basilisk: tempo entre o fim do processamento e a revisão concluída */
	reviewMs: number;
	documents: MockJobDocumentSeed[];
	failure?: { reason: string; message: string };
	metadata?: BasiliskJobMetadata;
	/** Cadastro: campos extraídos (exibidos após "Finalizado") */
	result?: Record<string, unknown>;
}

export const FT = MOCK_FILE_TYPE_IDS;

export function pdf(
	filename: string,
	fileTypeId: string,
	pageCount: number,
	sizeBytes: number,
	fileTypeName?: string,
): MockJobDocumentSeed {
	return { filename, fileTypeId, pageCount, sizeBytes, fileTypeName };
}

export interface AdmissionFields {
	nome: string;
	cpf: string;
	rg: string;
	nascimento: string;
	admissao: string;
	cargo: string;
	cbo: string;
	departamento: string;
	salario: string;
	pis: string;
	ctps: string;
	endereco: { logradouro: string; bairro: string; cidade: string; uf: string; cep: string };
	dependentes: { nome: string; parentesco: string; nascimento: string }[];
}

export function admissionResult(fields: AdmissionFields): Record<string, unknown> {
	return {
		nome_completo: fields.nome,
		cpf: fields.cpf,
		rg: fields.rg,
		data_nascimento: fields.nascimento,
		data_admissao: fields.admissao,
		cargo: fields.cargo,
		cbo: fields.cbo,
		departamento: fields.departamento,
		salario_base: fields.salario,
		jornada: '44h semanais — segunda a sexta, 08:00 às 17:48',
		tipo_contrato: 'CLT — prazo indeterminado',
		pis_pasep: fields.pis,
		ctps: fields.ctps,
		endereco: fields.endereco,
		dependentes: fields.dependentes,
		optante_vale_transporte: true,
	};
}
